import { createContentPropTypes } from '../../helpers/content';

const content = {
	managePaymentHeader: 'Your scheduled payments',
	managePaymentSubHeader:
		'Manage your scheduled payments including Direct Debits, standing orders and other payments you’ve set up to be made in the future.',
	mandateDifferenceHeader: "What's the difference between a Direct Debit and a standing order?",
	somethingWentWrongMsg: 'Something went wrong.',
	retryButtonLabel: 'Retry',
	viewPaymentHeader: 'Manage your scheduled payment',
	backButtonLabel: 'Back',
	editButtonLabel: 'Edit',
	cancelButtonLabel: 'Cancel',
	cancelPaymentButtonLabel: 'Cancel payment',
	OneOffPaymenttype: 'One-off payment',
	iftPaymentHeader: 'International payment',
	chapsPaymentHeader: 'CHAPS payment',
	importantInfoHeader: '<IndicativeHighlight.description>*Important information</IndicativeHighlight.description>',
	importantInfoText:
		'Your payment will be submitted using an indicative rate – this means the <IndicativeHighlight.description>figures highlighted are subject to change</IndicativeHighlight.description> until the payment is approved. The exact amounts will be clearly shown when it comes to authorising the payment.<p> </p><p>The settlement date has been estimated based on the payment being authorised by the cut-off time on the planned submission date.</p><p>Please note that any fees you’ve agreed to pay will be taken from your account as a separate payment.</p>',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
